"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Availability = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _hooks = require("../../../../hooks");
var _models = require("../../../../models");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const Availability = ({
  quantity
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    translations
  } = (0, _hooks.useTranslations)();
  const isOutOfStock = quantity > 0;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    "data-testid": getTestId(_models.TestId.PickupPointCardAvailability),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StockIndicator, {
      isOutOfStock: isOutOfStock
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StockText, {
      isOutOfStock: isOutOfStock,
      children: isOutOfStock ? `${quantity} ${translations.outOfStock}` : translations.allInStock
    })]
  });
};
exports.Availability = Availability;